import { browserName, browserVersion, isMobile, mobileModel, mobileVendor, osName, osVersion } from "react-device-detect"
import moment from "moment"
import { notification, Spin } from "antd"
import { EMAIL_VERIFICATION_STEP, EUROPEAN_COUNTRIES, INDIA_COUNTRY_ID, MCI_UPLOAD_STEP, STEPS_IN_PROFILE_COMPLETION, US_COUNTRIES } from "./appStatics"
import { AppLocalStorage, AppStorageKeys } from "../services/contracts"
import { LoadingOutlined } from "@ant-design/icons"
import { APP_VERSION, OMNICURIS_URL } from "../services/environments"

const antIcon = <LoadingOutlined style={{ fontSize: 64 }} spin />

export const isAuthenticated = () => {
  return AppLocalStorage.get(AppStorageKeys.userAccessToken, true)
}

export const verifyIfUserCountryCodeIsPresent = (userDetails) => {
  return userDetails.users && userDetails.users.userCountry && userDetails.users.userCountry.code
}

export const isEuropeanCountry = (countryId) => {
  return countryId && EUROPEAN_COUNTRIES.indexOf(parseInt(countryId)) >= 0
}

export const isUSCountry = (countryId) => {
  return countryId && US_COUNTRIES.indexOf(parseInt(countryId)) >= 0
}

export const isIndia = (countryId) => {
  return countryId && INDIA_COUNTRY_ID === parseInt(countryId)
}

export const doesBelongsToSameCountry = (courseCountryId, userCountryId) => {
  return courseCountryId && userCountryId && (courseCountryId === userCountryId || (isEuropeanCountry(courseCountryId) && isEuropeanCountry(userCountryId)) || (isUSCountry(courseCountryId) && isUSCountry(userCountryId)))
}

export const getCourseCountry = (courseOrganizations) => {
  let countryId = INDIA_COUNTRY_ID
  courseOrganizations.forEach((org) => {
    if (org.countryId && org.countryId !== INDIA_COUNTRY_ID && countryId === INDIA_COUNTRY_ID) {
      countryId = org.countryId
    }
  })
  return countryId
}

export const calculateTotalStepsToCompleteProfile = (userDetails) => {
  let totalSteps = []
  STEPS_IN_PROFILE_COMPLETION.forEach((step) => {
    if (step.forAllUsers || (!step.forAllUsers && verifyIfUserCountryCodeIsPresent(userDetails) && step.forUserCountries.indexOf(userDetails.users.userCountry.code) >= 0)) {
      totalSteps.push(step.name)
    }
  })
  return totalSteps
}

export const calculateCompletedStepsInUserProfile = (userDetails) => {
  let completedSteps = []
  STEPS_IN_PROFILE_COMPLETION.forEach((step) => {
    if (step.name === EMAIL_VERIFICATION_STEP && userDetails.users && userDetails.users.isEmailVerified) {
      completedSteps.push(EMAIL_VERIFICATION_STEP)
    }
    if (
      step.name === MCI_UPLOAD_STEP &&
      verifyIfUserCountryCodeIsPresent(userDetails) &&
      step.forUserCountries.indexOf(userDetails.users.userCountry.code) >= 0 &&
      (userDetails.users.isRegistrationVerified || userDetails.users.registrationStatus === "2")
    ) {
      completedSteps.push(MCI_UPLOAD_STEP)
    }
  })
  return completedSteps
}

export const openNotificationInToast = (type, title, description) => {
  // type:- success, info, warning, error
  notification[type]({
    message: title,
    description: description,
  })
}

export const checkForFeedBackFormCondition = (feedbackCollectiveStatus) => {
  return feedbackCollectiveStatus ? feedbackCollectiveStatus.feedbackMandatory && feedbackCollectiveStatus.quizAttempted && !feedbackCollectiveStatus.feedbackSubmitted : false
}

export const calcInputSize = () => {
  if (isMobile) {
    return "small"
  } else {
    return "large"
  }
}

export const calcWidth = () => {
  if (isMobile) {
    return "85vw"
  } else {
    return "40vw"
  }
}

export const isAlphabets = (ev) => {
  let key = ev.keyCode
  if (!(key === 32 || key === 9 || key === 8 || key === 46 || (key >= 35 && key <= 40) || (key >= 65 && key <= 90))) {
    ev.preventDefault()
  }
}

export const isValidEmail = (value) => {
  var mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
  if (value.match(mailformat)) {
    return true
  } else {
    return false
  }
}

export const conditionalCheckForQualificationMatch = (optionName, inputName, exactMatch) => {
  const existingQualification = optionName && optionName.toLowerCase().replaceAll(".", "").replaceAll("-", "").replaceAll(" ", "")
  const tempQualification = inputName && inputName.toLowerCase().replaceAll(".", "").replaceAll("-", "").replaceAll(" ", "")
  return exactMatch ? existingQualification === tempQualification : existingQualification.indexOf(tempQualification) >= 0
}

export const computeDisplayNameForZipCode = (cityForZipCode, countryName) => {
  let displayNameForZipCode = null
  if (cityForZipCode) {
    const areaName = cityForZipCode.adminName2 ? cityForZipCode.adminName2 : cityForZipCode.adminName1
    const stateName = cityForZipCode.adminName2 ? cityForZipCode.adminName1 : null
    const countryCode = countryName ? countryName : cityForZipCode.countryCode
    displayNameForZipCode = areaName + ", " + (stateName && stateName !== areaName ? stateName + ", " : "") + countryCode
  }
  return displayNameForZipCode
}

export const reloadPage = () => {
  window.location.reload()
}

export const isEmptyObj = (object) => {
  for (var key in object) {
    if (object.hasOwnProperty(key)) {
      return false
    } else {
      return true
    }
  }
}
export const getFeedTime = (time) => {
  const dateStr = moment(time)
    .subtract({ hours: 5, minutes: 30 })
    .format(isMobile ? "Do MMM YYYY" : "Do MMMM YYYY")

  return dateStr
}

export const getFirstName = (name, withDoctor) => {
  let split = name.split(" ")
  if (withDoctor) {
    return "Dr. " + split[0]
  } else {
    return split[0]
  }
}

export const capitalize = (str) =>
  str &&
  str
    .toLowerCase()
    .split(" ")
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ")

export const minutes = (time) => {
  return Math.floor(time / 60)
}

export const secondsToTime = (secs) => {
  if (secs) {
    secs = 60 * secs
    var hours = Math.floor(secs / (60 * 60))
    var divisor_for_minutes = secs % (60 * 60)
    var minutes = Math.floor(divisor_for_minutes / 60)
    var divisor_for_seconds = divisor_for_minutes % 60
    var seconds = Math.ceil(divisor_for_seconds)
    const h = hours !== 0 ? `${hours}h ` : ""
    const m = minutes !== 0 ? `${minutes}min` : ""
    return h + m
  }
}

export const lightenColor = (color, amount) => {
  return manipulateColor(color, amount, "lighten")
}

// Function to darken a color
export const darkenColor = (color, amount) => {
  return manipulateColor(color, amount, "darken")
}

export const componentToHex = (c) => {
  const hex = c.toString(16)
  return hex.length === 1 ? "0" + hex : hex
}

export const manipulateColor = (color, amount, type) => {
  // Remove the # symbol from the color
  if (!color) {
    return color
  }
  const hex = color.replace("#", "")

  // Convert the hex color to RGB
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // Calculate the new RGB values based on the specified type ('lighten' or 'darken')
  const newR = type === "lighten" ? Math.round(r + (255 - r) * amount) : Math.round(r * (1 - amount))
  const newG = type === "lighten" ? Math.round(g + (255 - g) * amount) : Math.round(g * (1 - amount))
  const newB = type === "lighten" ? Math.round(b + (255 - b) * amount) : Math.round(b * (1 - amount))

  // Convert the new RGB values back to hex
  const newHex = `#${componentToHex(newR)}${componentToHex(newG)}${componentToHex(newB)}`

  return newHex
}

export const GRAY_COLOR_HEX = "#8B94B9"

export const getAvatarInitials = (name) => {
  if (name && name !== "") {
    return name
      .replace("Dr. ", "")
      .split(" ")
      .slice(0, 2)
      .map((n) => n[0])
      .join("")
  }
}

const getHashOfString = (str) => {
  if (!str) {
    str = ""
  }
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  hash = Math.abs(hash)
  return hash
}

const normalizeHash = (hash, min, max) => {
  return Math.floor((hash % (max - min)) + min)
}

const hRange = [0, 360]
const sRange = [55, 100]
const lRange = [25, 75]

const generateHSL = (str) => {
  const hash = getHashOfString(str)
  const h = normalizeHash(hash, hRange[0], hRange[1])
  const s = normalizeHash(hash, sRange[0], sRange[1])
  const l = normalizeHash(hash, lRange[0], lRange[1])
  return [h, s, l]
}

export const HSLtoString = (str, opacity = "") => {
  const hsl = generateHSL(str)
  if (opacity !== "") {
    return `hsla(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%, ${opacity})`
  } else {
    return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`
  }
}

export const minutesToHour = (num) => {
  const hours = Math.floor(num / 60)
  const minutes = num % 60
  const h = hours !== 0 ? `${hours}h` : ""
  const m = minutes !== 0 ? `${minutes}m` : ""
  return h + " " + m
}

export const convertSecToHrMin = (secs) => {
  // var hours = Math.floor(secs / (60 * 60))
  // var divisor_for_minutes = secs % (60 * 60)
  // var minutes = Math.floor(divisor_for_minutes / 60)
  // var divisor_for_seconds = divisor_for_minutes % 60
  // var seconds = Math.ceil(divisor_for_seconds)
  // const h = hours !== 0 ? `${hours}h ` : ''
  // const m = minutes !== 0 ? `${minutes}m` : '0m'

  const hours = Math.floor(secs / 60)
  const minutes = secs % 60
  const h = hours !== 0 ? `${hours}h` : ""
  const m = minutes !== 0 ? `${minutes}m` : "0m"
  return h + " " + m
}

export const convertCredits = (value) => {
  if (value === 0) {
    return `No credit`
  } else if (value === 1) {
    return `${value} credit`
  } else {
    return `${value} credits`
  }
}

export const getNumberOrText = (value, keyCode, isNumber = false) => {
  let outputValue = ""
  if (value === undefined) {
    return outputValue
  }

  if (value.length >= 1 && keyCode != 8) {
    let regEx = isNumber ? /[A-Za-z\s.]+/gi : /[A-Za-z\s.]+/gi
    let inputValue = value.match(regEx)
    if (inputValue) {
      let name = ""
      for (let i = 0; i < inputValue.length; i++) {
        name = name + inputValue[i]
      }
      outputValue = trimForSpace(name)
    }
  } else {
    outputValue = trimForSpace(value)
  }
  return outputValue
}

export const trimForSpace = (str) => {
  if (str) {
    if (str.trim().length === 0) {
      return str.trim()
    }
  }
  return str
}

export const removeDupArr = (arr) => {
  let newArr = []
  if (arr.length > 0) {
    newArr = [...new Set(arr)]
  } else {
    newArr = []
  }
  return newArr
}

export const isValidMobile = (value) => {
  var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/
  if (value.match(phoneno)) {
    return true
  } else {
    return false
  }
}

export const isNumber = (value, keyCode) => {
  let result = ""
  if (value.length >= 1 && keyCode !== 8) {
    let inputVal = value.match(/[0-9]+/gi)
    if (inputVal) {
      result = inputVal[0]
    }
  } else {
    result = value
  }
  return result
}

export const isPdf = (url) => {
  const isPdf = url.split(/[#?]/)[0].split(".").pop().trim()
  if (isPdf === "pdf") {
    return true
  } else {
    return false
  }
}

export const isVideo = (url) => {
  const videos = ["mp4", "3gp", "ogg", "mkv", "mov", "flv", "avi", "webm", "wmv"]
  const extension = url && url.toLowerCase().split(/[#?]/)[0].split(".").pop()
  if (videos.includes(extension)) {
    return true
  } else {
    return false
  }
}

export const calcTime = (time) => {
  let date = new Date((time || "").replace(/-/g, "/").replace(/[TZ]/g, " ")),
    diff = (new Date().getTime() - date.getTime()) / 1000,
    day_diff = Math.floor(diff / 86400)

  if (isNaN(day_diff) || day_diff < 0) return

  return (
    (day_diff === 0 && ((diff < 60 && "just now") || (diff < 120 && "1 minute ago") || (diff < 3600 && Math.floor(diff / 60) + " minutes ago") || (diff < 7200 && "1 hour ago") || (diff < 86400 && Math.floor(diff / 3600) + " hours ago"))) ||
    (day_diff == 1 && "Yesterday") ||
    (day_diff < 7 && day_diff + " days ago") ||
    (day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago") ||
    (day_diff >= 31 && Math.ceil(day_diff / 30) + " months ago") ||
    (day_diff >= 365 && Math.ceil(day_diff / 365) + " years ago")
  )
}

export const calcDate = (time) => {
  return moment(time)
    .subtract({ hours: 5, minutes: 30 })
    .format(isMobile ? "Do MMM YYYY" : "Do MMMM YYYY")
}

export const copyToClipboard = (elementId) => {
  var temp = document.createElement("input")
  temp.setAttribute("value", document.getElementById(elementId).innerHTML)
  document.body.appendChild(temp)
  temp.select()
  document.execCommand("copy")
  document.body.removeChild(temp)
}

export const getGeolocation = () => {
  let latitude = ""
  let longitude = ""
  navigator.geolocation.getCurrentPosition(function (position) {
    latitude = position.coords.latitude
    longitude = position.coords.longitude
  })
  return { latitude, longitude }
}

export const checkForFeedback = (data) => {
  let feedback = undefined
  const courseCount = data.completedCourseCount ? data.completedCourseCount : 0
  const expertTalkCount = data.completedExpertTalkCount ? data.completedExpertTalkCount : 0
  const medshotsCount = data.completedMedshotsCount ? data.completedMedshotsCount : 0
  if (isAuthenticated()) {
    const isReviewed = localStorage.getItem("isReviewed") !== null ? JSON.parse(localStorage.getItem("isReviewed")) : undefined
    if (courseCount + expertTalkCount > 5 && isReviewed && !isReviewed) {
      feedback = true
    } else if (courseCount > 3 && isReviewed && !isReviewed) {
      feedback = true
    } else if (expertTalkCount > 5 && isReviewed && !isReviewed) {
      feedback = true
    } else if (medshotsCount > 30 && isReviewed && !isReviewed) {
      feedback = true
    } else {
      feedback = false
    }

    return feedback
  }
}

export const SpinLoader = () => {
  return (
    <div className="spinLoaderWrapper">
      <Spin indicator={antIcon} />
    </div>
  )
}

export const redirectToOmnicuris = (path, newTab = false) => {
  const accessToken = localStorage.getItem("userAccessToken")
  const orgId = localStorage.getItem("orgID")
  var extraParams = (accessToken ? "?accessToken=" + accessToken : "") + "&orgId=" + orgId
  window.open(path + extraParams, newTab ? "_blank" : "_self")
}

export const getLaunchTime = (time) => {
  const timeStr = `${moment(time).format("Do")} ${moment(time).format("MMM")} '${moment(time).format("YY")}, ${moment(time).format("h:mm A")}`
  return timeStr
}

export const getCompletedTime = (time) => {
  const timeStr = `${moment(time).format("Do")} ${moment(time).format("MMMM")} ${moment(time).format("YYYY")}`
  return timeStr
}

export const getDeviceInfo = () => {
  if (isMobile) {
    return `${trimSpace(browserName)}_${browserVersion} ${trimSpace(osName)}_${osVersion} MobileWeb ${mobileVendor}_${mobileModel} cme_v${APP_VERSION}`
  } else {
    return `${trimSpace(browserName)}_${browserVersion} ${trimSpace(osName)}_${osVersion} Desktop cme_v${APP_VERSION}`
  }
}

const trimSpace = (str) => {
  return str.replace(/([ ])/g, "")
}

export const isSmDevice = window.innerWidth <= 960
